module.exports = __webpack_public_path__ + "108bc519d295b0c0089ed239db14d37e.png";